import { clamp01 } from '../lib/math';
import type { GameState } from '../game/stateMachine';

/** Visage de l'ami perdu : la main reste figée, puis disparaît en fondu. */
export const FREEZE_MS = 300;
export const FADE_MS = 400;

export function handAlpha(msSinceFaceSeen: number): number {
  return msSinceFaceSeen <= FREEZE_MS ? 1 : clamp01(1 - (msSinceFaceSeen - FREEZE_MS) / FADE_MS);
}

/** Ma main tient le menton de mon ami dès que je l'ai attrapé, jusqu'au verdict. */
export function barbichetteActive(s: GameState): boolean {
  if (s.game !== 'barbichette') return false;
  switch (s.phase.name) {
    case 'grab':
      return s.meGrabbed === s.round;
    case 'chant':
    case 'duel':
    case 'paused':
      return true;
    default:
      return false;
  }
}
